import {
  getTwinslatorList,
  getTwinslatorInfo,
  favorite,
  favoriteList,
  mtCaseTranslate,
  getMyListByCondition,
  countallUnRead,
  getEnterpriseJoinList,
  switchEnterprise,
  userLevelPrivilege,
  getEnterpriseSettingsApi,
} from '@/http/api'

// 获取url上的enterpriseId
const urlParams = new URLSearchParams(window.location.search)
const enterpriseId = urlParams.get('enterpriseId') || ''

const state = {
  twinslatorListData: {},
  engineDetail: {},
  favoriteList: {},
  mtCaseTranslate: {},
  myList: {},
  msgCount: 0,
  enterpriseGlobalId: enterpriseId,
  enterpriseGlobalObj: '',
  enterpriseList: [],
  userLevel: {},
  settingDetail: {},
}
const getters = {
  accessToken: (state) => state.token,
}
const mutations = {
  changeKey(state, payload) {
    for (let i in payload) {
      state[i] = null
      state[i] = payload[i]
    }
  },
}
const actions = {
  getTwinslatorList({ commit }, params) {
    return new Promise((resolve, reject) => {
      getTwinslatorList(params)
        .then(({ data }) => {
          commit('changeKey', {
            twinslatorListData: data.data,
          })
          resolve(data.data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  getTwinslatorInfo({ commit }, params) {
    return new Promise((resolve, reject) => {
      getTwinslatorInfo(params)
        .then(({ data }) => {
          commit('changeKey', {
            engineDetail: data.data,
          })
          resolve(data.data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  favorite({ commit }, params) {
    return new Promise((resolve, reject) => {
      favorite(params)
        .then(({ data }) => {
          resolve(data.data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  favoriteList({ commit }, params) {
    return new Promise((resolve, reject) => {
      favoriteList(params)
        .then(({ data }) => {
          commit('changeKey', {
            favoriteList: data.data.list,
          })
          resolve(data.data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  getMyListByCondition({ commit }, params) {
    return new Promise((resolve, reject) => {
      getMyListByCondition(params)
        .then(({ data }) => {
          commit('changeKey', {
            myList: data.data.list,
          })
          resolve(data.data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  mtCaseTranslate({ commit }, params) {
    return new Promise((resolve, reject) => {
      mtCaseTranslate(params)
        .then(({ data }) => {
          commit('changeKey', {
            mtCaseTranslate: data.data,
          })
          resolve(data.data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  //检测消息红点接口
  countallUnRead({ commit }) {
    return new Promise((resolve, reject) => {
      countallUnRead({})
        .then(({ data }) => {
          commit('changeKey', {
            msgCount: data ? data.total : 0,
          })
          resolve(data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  setEnterpriseInfo({ commit }, params) {
    commit('changeKey', {
      enterpriseGlobalObj: {
        id: params.id,
        name: params.name,
        logo: params.logo,
        role: params.role,
        permission: params.permission,
      },
      enterpriseGlobalId: params.id,
      enterpriseList: params.list,
    })
  },
  // 获取企业列表
  getEnterpriseJoinListFunc({ commit }) {
    return new Promise((resolve, reject) => {
      getEnterpriseJoinList({})
        .then(({ data }) => {
          const list = data.data || []
          if (list.length > 0) {
            const arr = list.filter((item) => item.selected)
            commit('changeKey', {
              enterpriseGlobalObj: {
                id: arr[0].id,
                name: arr[0].name,
                logo: arr[0].logo,
                role: arr[0].role,
                permission: arr[0].permission,
              },
              enterpriseGlobalId: arr[0].id,
              enterpriseList: list,
            })
          }
          resolve(list)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  //获取企业会员权益;
  getUserLevelPrivilege({ commit, state }) {
    return new Promise((resolve, reject) => {
      userLevelPrivilege({
        type: state.enterpriseGlobalId == 'personal' ? 'personal' : 'team',
        enterpriseId: state.enterpriseGlobalId,
      }).then((res) => {
        // console.log(res);
        let result = res.data
        commit('changeKey', {
          userLevel: result,
        })
      })
    })
  },
  // 获取企业配置信息
  getEnterpriseSettingsFunc({ commit, state }) {
    return new Promise((resolve, reject) => {
      getEnterpriseSettingsApi({
        enterpriseId: state.enterpriseGlobalId,
      })
        .then((res) => {
          const data = res.data.data
          commit('changeKey', {
            settingDetail: data,
          })
          resolve(data)
        })
        .catch((rej) => {
          reject()
        })
    })
  },
  // 切换企业
  switchEnterpriseFunc({ commit }, id) {
    return new Promise((resolve, reject) => {
      switchEnterprise({
        id,
      })
        .then((res) => {
          const data = res.data || {}
          commit('changeKey', {
            enterpriseGlobalObj: {
              id,
              name: data.name,
              logo: data.logo,
              role: data.role,
              permission: data.permission,
            },
            enterpriseGlobalId: id,
          })
          resolve()
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
}
export default { state, getters, mutations, actions }
